import * as React from "react";

import { ActionPanelContainer } from "../ActionPanel/ActionPanelContainer";
import { PanelType } from "../PanelTypes";
import { AttachmentNames } from "../FufAndAttachmentsUploadModal/FufAndAttachmentsUploadModalTypes";
import { useFormSettings } from "../../../FormObjectProvider";

import { AtBottom, Root, UnitList } from "./Menu.styles";

interface MenuProps {
    className?: string;
    children: React.ReactNode;
    isHideOrgName?: boolean;
    disableAddButtonOnPanelUnits?: string[];
    checkErrors: () => void;
    hiddenConvertLink: boolean;
    setHiddenOrgName: (x: boolean) => void;
    setPanelState: (x: PanelType) => void;
    transferText?: string;
    uploadFufButtonEnabled: boolean;
    fufSizeTooLargeErrorText?: string | React.ReactNode;
    uploadFufLightboxHideDemandNameButton: boolean;
    uploadFufLightboxTitle?: string;
    uploadFufLightboxAlert?: string;
    attachmentNames?: AttachmentNames;
    uploadFufAttachmentsButtonEnabled: boolean;
}

const ActionPanelAtBottom = AtBottom.withComponent(ActionPanelContainer);

export function Menu(props: MenuProps): React.ReactElement {
    const { hidePanelActions } = useFormSettings();
    if (!React.isValidElement(props.children)) {
        throw new Error("Menu children must be a single UnitList element");
    }
    return (
        <Root className={props.className}>
            <UnitList>{props.children}</UnitList>
            {hidePanelActions ? null : (
                <ActionPanelAtBottom
                    checkErrors={props.checkErrors}
                    hiddenConvertLink={props.hiddenConvertLink}
                    isHideOrgName={props.isHideOrgName}
                    setHiddenOrgName={props.setHiddenOrgName}
                    setPanelState={props.setPanelState}
                    transferText={props.transferText}
                    uploadFufButtonEnabled={props.uploadFufButtonEnabled}
                    fufSizeTooLargeErrorText={props.fufSizeTooLargeErrorText}
                    uploadFufLightboxHideDemandNameButton={props.uploadFufLightboxHideDemandNameButton}
                    uploadFufLightboxTitle={props.uploadFufLightboxTitle}
                    uploadFufLightboxAlert={props.uploadFufLightboxAlert}
                    attachmentNames={props.attachmentNames}
                    uploadFufAttachmentsButtonEnabled={props.uploadFufAttachmentsButtonEnabled}
                />
            )}
        </Root>
    );
}
